import { HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationConfig } from '@config/application.config';
import { HttpUtil } from '@shared/util/http.util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileApiService {
  constructor(private readonly httpUtil: HttpUtil) {
  }

  public upload(file: File): Observable<HttpEvent<void>> {
    const requestData: FormData = new FormData();

    requestData.append('file', file, file.name);

    return this.httpUtil.upload(`${ ApplicationConfig.apiUrl }/patients/me/photo`, requestData, { ignoreError: true, silentMode: true, reportProgress: true });
  }

}
